import { useTranslation } from "react-i18next";

import type { OneValueMeasurement } from "~/api/lastMeasurements";
import { RespiratoryRate } from "~/icons";
import { formatBackendDate } from "~/utils";
import { HealthDetails } from "..";

interface RespiratoryRateProps {
  measurement: OneValueMeasurement | null;
}

export const RespiratoryRateCard = ({ measurement }: RespiratoryRateProps) => {
  const { t } = useTranslation();

  const val = measurement ? measurement.value.toString() : t("health.no_data");

  return (
    <HealthDetails.Card>
      <HealthDetails.CardHeader>
        <RespiratoryRate className="text-primary-40 dark:text-primary-80" />
        <HealthDetails.CardTitle>
          {t("health.respiratory_rate")}
        </HealthDetails.CardTitle>
      </HealthDetails.CardHeader>
      <HealthDetails.CardBody>
        <HealthDetails.CardResult>{val}</HealthDetails.CardResult>
        <HealthDetails.CardDetails>
          <HealthDetails.CardUnit>{t("health.min")}</HealthDetails.CardUnit>
          {measurement && (
            <HealthDetails.CardDate>
              {formatBackendDate(measurement.date)}
            </HealthDetails.CardDate>
          )}
        </HealthDetails.CardDetails>
      </HealthDetails.CardBody>
    </HealthDetails.Card>
  );
};
